import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleList() {
  const featuredArticles = articles.slice(0, 4);

  return (
    <section className="py-12 md:py-16 bg-background-100/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              热门文章
            </h2>
            <p className="text-sm text-foreground-600 mt-1">观影攻略、行业资讯、深度解读</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group cursor-pointer p-4 rounded-lg bg-background-100 border border-background-200/60 hover:border-background-300/60 transition-all duration-300"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[16/9] bg-background-200 mb-4">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  title={`${article.title} - 在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs px-2 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">
                  {article.category}
                </span>
                <span className="text-xs text-foreground-600">{article.readTime}</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-2 mt-3 pt-3 border-t border-background-200/60">
                <span className="text-xs text-foreground-600">{article.author}</span>
                <span className="text-xs text-foreground-500">·</span>
                <span className="text-xs text-foreground-600">{article.date}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}